<template>
  <VueQueryDevtools v-if="rtConfPub.appEnv !== 'prod'" />
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>
<script setup lang="ts">
import { ofetch } from 'ofetch';
import { VueQueryDevtools } from '@tanstack/vue-query-devtools';
import { type PublicationContext } from '~/types';
globalThis.$fetch = ofetch.create({ retry: 3, retryDelay: 100 });
const rtConfPub = useRuntimeConfig().public as unknown as PublicationContext;
</script>
